import dayjs from 'dayjs';

import { MONTH_LIMIT } from '#client/constants/date';

export const getMonthSelectOptions = () => {
  const monthSelectOptions = [
    {
      name: 'All',
      key: 'all'
    }
  ];
  for (let i = 0; i <= MONTH_LIMIT; i += 1) {
    const date = dayjs().subtract(i, 'month');
    const name = date.format('MMM YYYY');
    const key = date.format('YYYY-M');
    monthSelectOptions.push({
      name,
      key
    });
  }

  return monthSelectOptions;
};

/**
 * Function convert option value to api value
 *
 * @param {string} date - value format: 2022-8
 * @returns {{from: string, to: string}} - The api request value
 */
export const getDateRange = (date) => {
  const dateParts = date.split('-');
  const lastDayInMonth = new Date(dateParts[0], dateParts[1], 0);
  const untilDate = dayjs(lastDayInMonth).endOf('date');
  const to = untilDate.toISOString();
  const from = untilDate
    .subtract(lastDayInMonth.getDate() - 1, 'd')
    .startOf('date')
    .toISOString();
  return {
    from,
    to
  };
};

/**
 * get the diff time to now
 *
 * @param {string} startedTime
 * @param {string} unit
 * @returns {number} - the estimate transfer day
 */
export const getDiffTime = (startedTime, unit = 'd') => {
  const from = dayjs(startedTime);
  const isValidTime = startedTime && from.isValid();

  return isValidTime ? dayjs().diff(from, unit) : 0;
};

/**
 * Calculate transfer day
 *
 * @param {string} date
 * @returns {string} - the estimate transfer day
 */
export const calculateTransferDays = (date) => {
  const currentDate = dayjs(date);
  const isValidTime = currentDate && currentDate.isValid();
  if (!isValidTime) {
    return '';
  }

  const dayOfWeek = currentDate.day();

  switch (dayOfWeek) {
    // Monday and Tuesday, plus 3 days
    case 1:
    case 2:
      return currentDate.add(3, 'day').toISOString();
    // Wednesday, Thursday, Friday or Saturday, plus 5 days
    case 3:
    case 4:
    case 5:
    case 6:
      return currentDate.add(5, 'day').toISOString();
    // Sunday, plus 4 days
    case 0:
      return currentDate.add(4, 'day').toISOString();
    default:
      return currentDate.add(3, 'day').toISOString();
  }
};
